import types from "../types";

// initial state
const state = {
  isVisibleDialogSaveAndExit: false,
};

// getters
const getters = {
  [types.getters.isVisibleDialogSaveAndExit]: (state) =>
    state.isVisibleDialogSaveAndExit,
};

// actions
const actions = {
  [types.actions.setIsVisibleDialogSaveAndExit](
    { commit },
    isVisibleDialogSaveAndExit,
  ) {
    commit(
      types.mutations.setIsVisibleDialogSaveAndExit,
      isVisibleDialogSaveAndExit,
    );
  },
};

// mutations
const mutations = {
  [types.mutations.setIsVisibleDialogSaveAndExit](
    state,
    isVisibleDialogSaveAndExit,
  ) {
    state.isVisibleDialogSaveAndExit = isVisibleDialogSaveAndExit;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogSaveAndExit.js